// src/data/hireNodejsPageData.js

export const hireNodePageContentArabic = {
  // Helmet Content
  helmet: {
    title: "وظّف مطوري Node.js | خدمات تطوير Node.js",
    description: "وظّف أفضل مطوري Node.js للحصول على حلول خلفية فعّالة وقابلة للتوسع. خدمات تطوير Node.js متخصصة لنمو عملك.",
  },

  // Main Banner Content
  mainBanner: {
    backgroundImage: `url(/images/hire-page-images/hire-node.avif)`,
    image: "", // Keep if it's dynamic, otherwise remove
    mainHeading: "وظّف خبراء Node.js لتقديم حلول قابلة للتوسع وعالية الأداء",
    content: "سواء كنت شركة ناشئة أو مؤسسة، يتخصص مطورو Node.js المتميزون لدينا في بناء تطبيقات سريعة وآمنة وقابلة للتوسع ومصممة خصيصًا لتلبية احتياجات عملك.",
    btnText: "استشر مطوري Node لدينا",
    bannerList: [
      { list: "مطورون مستقلون وبدوام كامل" },
      { list: "نماذج توظيف مرنة" },
      { list: "مجموعة مواهب عالمية" },
    ],
  },

  // Node.js Expertise Section
  nodeExpertise: { // Changed from 'HireNodejsServicesData' for consistency & clarity
    btnText: "حدد موعدًا لإجراء مكالمة اليوم",
    heading: "خبرتنا في تطوير Node.js",
    description: "يتخصص مطورو Node.js لدينا في بناء أنظمة خلفية عالية الأداء وقابلة للتوسع للشركات من جميع الأحجام. من التطبيقات في الوقت الفعلي إلى الحلول على مستوى المؤسسات، نضمن التكامل السلس والأداء السريع والأمان من الدرجة الأولى.",
    servicesData: [
      {
        title: "استشارات Node.js",
        description: "احصل على إرشادات الخبراء حول البنية، وتحسين الأداء، وقابلية التوسع لزيادة إمكانات تطبيقات Node.js الخاصة بك.",
        icon: "/images/hire-page-icons/hrie-node-icons1.svg",
      },
      {
        title: "تطوير الويب باستخدام Node.js",
        description: "نحن نبني تطبيقات ويب غنية بالميزات ومتجاوبة وقابلة للتوسع باستخدام Node.js، مما يضمن وظائف سلسة عبر جميع الأجهزة والمنصات.",
        icon: "/images/hire-page-icons/hrie-node-icons2.svg",
      },
      {
        title: "تطوير واجهة برمجة تطبيقات Node.js (API)",
        description: "يقوم مطورونا بإنشاء واجهات برمجة تطبيقات قوية وفعالة، مما يتيح الاتصال السلس بين التطبيقات ويعزز اتصال النظام.",
        icon: "/images/hire-page-icons/hrie-node-icons3.svg",
      },
      {
        title: "تطوير أنظمة إدارة المحتوى (CMS) وبوابات Node.js",
        description: "طوّر أنظمة إدارة محتوى وبوابات ويب مخصصة سهلة الاستخدام وقابلة للتوسع وسهلة الإدارة، مصممة لتناسب احتياجات عملك.",
        icon: "/images/hire-page-icons/hrie-node-icons4.svg",
      },
      {
        title: "الترحيل إلى Node.js",
        description: "انقل تطبيقاتك الحالية بسلاسة إلى Node.js بأقل وقت توقف، مما يضمن تحسين الأداء وسهولة الصيانة.",
        icon: "/images/hire-page-icons/hrie-node-icons5.svg",
      },
      {
        title: "التكامل مع الحلول الحالية",
        description: "نحن متخصصون في دمج تطبيقات Node.js مع خدمات ومنصات الطرف الثالث، مما يخلق نظامًا موحدًا ومبسطًا.",
        icon: "/images/hire-page-icons/hrie-node-icons6.svg",
      },
      {
        title: "حلول التجارة الإلكترونية Node.js",
        description: "ابنِ منصات تجارة إلكترونية آمنة وعالية الأداء توفر تجربة تسوق سلسة وقابلية للتوسع وأمانًا معززًا.",
        icon: "/images/hire-page-icons/hrie-node-icons7.svg",
      },
      {
        title: "دعم وصيانة Node.js",
        description: "ضمان الأداء الأمثل من خلال خدمات الدعم والصيانة المستمرة لدينا، مع الحفاظ على تطبيقك محدثًا وآمنًا ويعمل بسلاسة.",
        icon: "/images/hire-page-icons/hrie-node-icons8.svg",
      },
    ],
  },

  // Why Choose Us (Development Performance)
  whyChooseUs: {
    btnText: "توظيف مطور اليوم",
    heading: "لماذا توظّف مطوري Node.js ",
    greenHeading: "من بيتسكلان؟",
    subHeading: "في بيتسكلان، نستفيد من Node.js جنبًا إلى جنب مع أحدث تقنيات الواجهة الأمامية والجوال لبناء تطبيقات قوية وقابلة للتوسع وعالية الأداء مصممة خصيصًا لاحتياجات عملك. سواء كنت تقوم بتطوير نظام أساسي للويب أو حل جوال، فإننا نضمن الكفاءة والأمان وتجربة مستخدم استثنائية.",
    solutionsData: [ // Renamed from HireNodejsSolutionsData
      {
        icon: "/images/hire-page-icons/chose-ror-section1.svg",
        title: "الوصول إلى خبراء Node.js المعتمدين",
        description: "وظّف مطوري Node.js من الطراز الأول الذين تم فحصهم مسبقًا لخبرتهم الفنية ومهارات حل المشكلات وإتقان اللغة الإنجليزية، مما يضمن اتصالًا واضحًا وتطويرًا عالي الجودة.",
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section2.svg",
        title: "ابحث عن المطابق الصحيح على الفور",
        description: "لا مزيد من إضاعة الوقت في السير الذاتية التي لا نهاية لها! عملية التوظيف المدعومة بالذكاء الاصطناعي لدينا تربطك على الفور بأفضل مطوري Node.js، مما يجعل التوظيف سريعًا وسهلًا وخاليًا من المتاعب.",
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section3.svg",
        title: "وفر الكثير مع المواهب العالمية",
        description: "استفد من شبكة تضم أكثر من 450,000 مطور في أكثر من 190 دولة وقلل تكاليف التوظيف بنسبة تصل إلى 58% – دون المساومة على الجودة.",
        noBorder: true,
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section4.svg",
        title: "احصل على دعم توظيف شخصي",
        description: "قد يكون العثور على المطور المناسب أمرًا صعبًا. لهذا السبب، يوجهك متخصصو التوظيف الخبراء لدينا في كل خطوة، مما يضمن اتخاذ أفضل قرار توظيف بثقة.",
      },
    ],
  },

  // Technology Combinations
  techCombinations: { // Renamed from techCombinations
    heading: "أفضل تركيبات Node.js لتطوير عالي الأداء",
    description: "استفد من قوة Node.js مع أفضل تركيبات التكنولوجيا لبناء تطبيقات سريعة وقابلة للتوسع وفعالة. وظّف خبراء Node.js لضمان تطوير خلفي سلس وأداء استثنائي.",
    combinations: [
      {
        title: "Node.js + React + MongoDB",
        description: "يساعد Node.js كواجهة خلفية مع React على الواجهة الأمامية و MongoDB كقاعدة بيانات في بناء تطبيقات ويب سريعة وقابلة للتوسع وفي الوقت الفعلي.",
        icons: ["nodejs.svg", "react.svg", "mongodb.svg"],
      },
      {
        title: "Node.js + Angular + MySQL",
        description: "تُنشئ Angular لواجهة أمامية منظمة، و Node.js لواجهة خلفية عالية الأداء، و MySQL كقاعدة بيانات حل ويب قوي وكامل المكدس.",
        icons: ["nodejs.svg", "angular.svg", "mysql-whale-icon.svg"],
      },
      {
        title: "Node.js + Vue.js + PostgreSQL",
        description: "تضمن Vue.js على الواجهة الأمامية، و Node.js كواجهة خلفية، و PostgreSQL كقاعدة بيانات تطويرًا آمنًا وفعالًا للتطبيقات الحديثة.",
        icons: ["nodejs.svg", "vue-js.svg", "postgres.svg"],
      },
      {
        title: "Node.js + GraphQL + DynamoDB",
        description: "تتيح GraphQL الاستعلام الفعال عن البيانات، وتدير Node.js منطق الخادم، وتقدم DynamoDB تخزين NoSQL قابلاً للتوسع للتطبيقات التفاعلية للغاية.",
        icons: ["nodejs.svg", "graphql.svg", "dynamodb.svg"],
      },
    ],
  },

  // Hire Steps
  hireSteps: { // Renamed from HireNodejsSteps
    btnText: "دعنا نجد المطور المثالي لك",
    heading: "وظّف مطوري Node.js في 4 خطوات بسيطة",
    subHeading: "العثور على مطور Node.js المثالي سريع وخالٍ من المتاعب من خلال عملية التوظيف المبسطة المكونة من 4 خطوات.",
    steps: [
      {
        title: "اختر نموذج التعاقد الخاص بك",
        description: "اختر نموذج توظيف يتوافق مع احتياجات مشروعك - بدوام كامل، أو بدوام جزئي، أو بالساعة. نحن نقدم خيارات مرنة لتناسب ميزانيتك وجدولك الزمني.",
        icon: "/images/hire-page-setps-icons/icon-1.svg",
      },
      {
        title: "فحص واختيار مطوري Node.js",
        description: "احصل على قائمة منسقة من أفضل مطوري Node.js. راجع ملفاتهم الشخصية وخبراتهم ومهاراتهم للعثور على الأنسب لمشروعك.",
        icon: "/images/hire-page-setps-icons/icon-2.svg",
      },
      {
        title: "إجراء مقابلة فردية",
        description: "قيّم المرشحين المختصرين من خلال المقابلات الفنية واختبارات البرمجة المباشرة. قيّم مهاراتهم في حل المشكلات وخبراتهم ومدى ملاءمتهم الثقافية.",
        icon: "/images/hire-page-setps-icons/icon-3.svg",
      },
      {
        title: "الاستقبال السلس في غضون 24-48 ساعة",
        description: "بمجرد اتخاذ قرارك، ينضم مطور Node.js الخاص بك إلى فريقك في غضون 24-48 ساعة - مما يضمن بداية سريعة وسلسة لمشروعك.",
        icon: "/images/hire-page-setps-icons/icon-4.svg",
      },
    ],
  },

  // Cover The Stack
  coverTheStack: {
    whereStart: "الواجهة الخلفية",
    mainHeading: "وظّف خبراء Node.js لتقديم حلول ويب قابلة للتوسع وعالية الأداء",
    subHeading:
      "في بيتسكلان، ندعم رحلة تطوير الواجهة الخلفية الخاصة بك باستخدام مجموعة تقنيات Node.js المتطورة التي تضمن السرعة وقابلية التوسع والكفاءة. يتخصص مطورو Node.js ذوو الخبرة لدينا في بناء تطبيقات في الوقت الفعلي وكثيفة البيانات مصممة خصيصًا لاحتياجات عملك.",
    tabs: [
      "الواجهة الخلفية",
      "قواعد البيانات",
      "السحابة وعمليات التطوير والتشغيل",
      "الاختبار",
      "الأدوات والمرافق",
    ],
    tabItems: [
      { tab: "الواجهة الخلفية", name: "Express.js", icon: "/images/database5.png" },
      { tab: "الواجهة الخلفية", name: "Nest Js", icon: "/images/database2.png" },

      { tab: "قواعد البيانات", name: "MongoDB", icon: "/images/db3.png" },
      { tab: "قواعد البيانات", name: "PostgreSQL", icon: "/images/tech-stack-icons/postgres.svg" },
      { tab: "قواعد البيانات", name: "MySQL", icon: "/images/db5.png" },

      { tab: "السحابة وعمليات التطوير والتشغيل", name: "AWS", icon: "/images/cloud3.png" },
      { tab: "السحابة وعمليات التطوير والتشغيل", name: "Docker", icon: "/images/tech-stack-icons/docker.svg" },
      { tab: "السحابة وعمليات التطوير والتشغيل", name: "Kubernetes", icon: "/images/tech-stack-icons/kubernetes.svg" },

      { tab: "الاختبار", name: "Postman", icon: "/images/tech-stack-icons/postman.svg" },
      { tab: "الاختبار", name: "Jmeter", icon: "/images/tech-stack-icons/seaborn.svg" },
      { tab: "الاختبار", name: "Selenium", icon: "/images/tech-stack-icons/selenium.svg" },
      { tab: "الاختبار", name: "Cypress", icon: "/images/tech-stack-icons/cypress.svg" },

      { tab: "الأدوات والمرافق", name: "TypeScript", icon: "/images/tech-stack-icons/typescript.svg" },
      { tab: "الأدوات والمرافق", name: "GraphQL", icon: "/images/tech-stack-icons/graphql.svg" },
    ],
  },

  // Expert Facts
  expertFacts: { // Renamed from HireNodejsFactsData & mainBannerImg for background
    btnText: "حجز موعد",
    heading: "حقائق سريعة حول ",
    greenHeading: "فريقنا المتخصص في Node.js",
    facts: [
      {
        text: "خبراء مطوري Node.js – يتكون فريقنا من محترفين ذوي مهارات عالية متخصصين في تطوير الواجهة الخلفية القابلة للتوسع باستخدام Node.js.",
      },
      {
        text: "حلول على مستوى المؤسسات – نحن نبني أنظمة خلفية قوية تدعم كل شيء من التطبيقات الصغيرة إلى المنصات الكبيرة على مستوى المؤسسات.",
      },
      { text: "خبرة عميقة في JavaScript و Node.js – مطورونا بارعون في أطر عمل Node.js و JavaScript الحديثة لتطوير تطبيقات سريعة وموثوقة." },
      {
        text: "تطوير واجهة برمجة تطبيقات سلس – نحن نصمم ونحسن واجهات برمجة التطبيقات، مما يضمن تكامل تطبيقاتك بسلاسة مع خدمات ومنصات الطرف الثالث.",
      },
      { text: "تطبيقات عالية الأداء وفي الوقت الفعلي – يتفوق فريقنا في تطوير تطبيقات في الوقت الفعلي تتوسع بسهولة مع نمو عملك." },
      { text: "تكامل النظام الكامل – نحن متخصصون في ربط تطبيقات Node.js بقواعد البيانات، وخدمات السحابة، والأدوات الخارجية للتوافق السلس." },
    ],
    backgroundImage: `url(/images/hire-page-images/hire-node-arabic.avif)`, // From mainBannerImg.factBackgroundImage
  },

  // App Idea Section
  appIdeaSection: { // Renamed from HirePageAppIdea
    heading: "تحقق من فكرة تطبيقك بنموذج أولي في غضون 6-8 أسابيع فقط!",
    content: "لديك فكرة تطبيق ولكن غير متأكد من كيفية المتابعة؟ يمكن لخبراء مطوري Node.js لدينا مساعدتك في إحياءها بنموذج أولي وظيفي بالكامل في غضون 6-8 أسابيع فقط!",
  },

  // Engagement Models
  hirePageEngagementModels: {
    btnText: "ابدأ الآن",
    headingContent: [
      { text: "نماذج التعاقد" },
      { text: "المرنة لدينا" },
    ],
    discription: "اختر نموذج التعاقد الذي يناسب احتياجات مشروعك! سواء كنت بحاجة إلى مطورين بدوام كامل أو جزئي أو بالساعة، فإننا نقدم خيارات مرنة لضمان التعاون السلس وأقصى قدر من الكفاءة طوال مشروعك.",
    hiringDetails: [ // Renamed from hiringDetails
      {
        text: "توظيف بالساعة",
        hours: "48",
        timeUnit: "ساعة",
        icon: "time.svg", // Added full path
        bgColor: "#FDFDFF",
        durationLabel: "المدة",
        duration: "8 ساعات/يوم",
        minimumDaysLabel: "الحد الأدنى للأيام",
        minimumDays: "30 يومًا",
        billingLabel: "الفوترة",
        billing: "شهريًا",
        startWorkPhrase: "ابدأ العمل في غضون "
      },
      {
        text: "توظيف بدوام كامل",
        hours: "72",
        timeUnit: "ساعة",
        icon: "full-time.svg", // Added full path
        bgColor: "#FFFEFA",
        durationLabel: "المدة",
        duration: "8 ساعات/يوم",
        minimumDaysLabel: "الحد الأدنى للأيام",
        minimumDays: "30 يومًا",
        billingLabel: "الفوترة",
        billing: "شهريًا",
        startWorkPhrase: "ابدأ في غضون "
      },
      {
        text: "توظيف بدوام جزئي",
        hours: "48",
        timeUnit: "ساعة",
        icon: "part-time.svg", // Added full path
        bgColor: "#FDFFFA",
        durationLabel: "المدة",
        duration: "8 ساعات/يوم",
        minimumDaysLabel: "الحد الأدنى للأيام",
        minimumDays: "30 يومًا",
        billingLabel: "الفوترة",
        billing: "شهريًا",
        startWorkPhrase: "ابدأ في غضون "
      },
    ],
  },

  // FAQ Section
  faqSection: { // Renamed from HireNodejsFaqData
    mainHeading: "الأسئلة المتداولة",
    subHeading: "اكتشف إجابات لأسئلة شائعة حول Node.js",
    faqData: [
      {
        id: "collapseOne",
        question: "ما هو استخدام Node.js؟",
        answer: "يُستخدم Node.js بشكل شائع لبناء تطبيقات خلفية سريعة وقابلة للتوسع. إنه مثالي لإنشاء تطبيقات في الوقت الفعلي، وواجهات برمجة التطبيقات (APIs)، وخدمات خلفية يمكنها التعامل مع كميات كبيرة من الطلبات.",
      },
      {
        id: "collapseTwo",
        question: "لماذا يجب علي توظيف مطوري Node.js من Arc؟",
        answer: "خبراء مطوري Node.js لدينا ماهرون في إنشاء أنظمة خلفية سريعة وقابلة للتوسع. لديهم المهارات اللازمة لضمان أداء تطبيقك بشكل جيد ودمجه بسلاسة مع الخدمات الأخرى.",
      },
      {
        id: "collapseThree",
        question: "كم يستغرق تطوير تطبيق Node.js؟",
        answer: "يعتمد الجدول الزمني على تعقيد المشروع. قد تستغرق التطبيقات الصغيرة والمتوسطة بضعة أسابيع، بينما قد تستغرق الأنظمة الأكبر حجمًا بضعة أشهر. نعمل معك لتحديد مواعيد نهائية واقعية.",
      },
      {
        id: "fourth",
        question: "هل يمكنك نقل تطبيقي الحالي إلى Node.js؟",
        answer: "نعم! يمكن لخبراء Node.js لدينا مساعدتك في نقل تطبيقاتك الحالية إلى Node.js، مما يضمن انتقالًا سلسًا واستمرار تطبيقك في العمل بكفاءة.",
      },
      {
        id: "fifth",
        question: "ما أنواع التطبيقات التي يمكن بناؤها باستخدام Node.js؟",
        answer: "يمكنك بناء مجموعة واسعة من التطبيقات باستخدام Node.js، بما في ذلك منصات التجارة الإلكترونية، وتطبيقات الدردشة في الوقت الفعلي، وواجهات برمجة التطبيقات (APIs)، وأنظمة إدارة المحتوى (CMS)، والمزيد. إنه رائع للتطبيقات عالية الأداء وفي الوقت الفعلي.",
      },
      {
        id: "sixth",
        question: "كيف يحسن Node.js أداء التطبيق؟",
        answer: "Node.js سريع وخفيف الوزن. يستخدم بنية غير مانعة وموجهة بالأحداث، مما يساعده على التعامل مع العديد من الطلبات في وقت واحد. هذا يجعل تطبيقك أسرع وأكثر قابلية للتوسع.",
      },
    ],
  },
  // You can remove or keep these if they are not directly used by components anymore
  // HireNodejsStacksdata: [],
  // HireNodejsBenefitsData: [],
  // HireNodejsWhoWeServeData: [],
  // HireNodejsPageDeliverData: [],
  // HireNodejsSlidesData: [],
};